export * from './last-elements-opened.component';
export * from './last-elements-opened.module';
